import { useTranslation } from 'next-i18next'

export default function PluginsToolbar ({ sort, onSortChange, plugins }) {
  const { t } = useTranslation(['plugins'])

  return (
    <div className="container">
      <div className="row d-md-flex justify-content-between align-items-center">
        {
          plugins.data.length === 0 && (
            <div className="col-12 col-md-auto">
              <svg className="me-0 me-lg-3 mb-1 mb-lg-0"
                width="32"
                height="32"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.57946 0.0847742C7.71257 0.02884 7.85555 0 8.00005 0C8.14389 0 8.28622 0.0285785 8.41882 0.0840135L15.2651 2.67419L15.2677 2.67514C15.4261 2.73597 15.568 2.83215 15.6827 2.95573L8.00011 5.91336L0.323746 2.95814C0.44721 2.84445 0.594902 2.76025 0.755662 2.71193L7.57946 0.0847742ZM4.81606e-05 4.36431V12.1001H0L9.63211e-05 12.1075C0.00306055 12.3358 0.0743157 12.5579 0.20468 12.7453C0.335045 12.9327 0.518543 13.0768 0.731525 13.159L0.731881 13.1591L7.28585 15.6824V7.16917L4.81606e-05 4.36431ZM8.71442 7.16915V15.6823L15.2682 13.1591L15.2686 13.159C15.4816 13.0768 15.665 12.9327 15.7954 12.7453C15.9258 12.5579 15.997 12.3358 16 12.1075V12.1001V4.36435L8.71442 7.16915Z"
                  fill="black"
                  fillOpacity="1"
                />
              </svg>
              <span>{t('no_products')}</span>
            </div>
          )
        }
        {
          plugins.data.length > 0 && (
            <div className="col-12 col-md-auto d-none d-md-block">
              {
                t(
                  'browse_all.pagination',
                  {
                    from: plugins?.meta.from,
                    to: plugins?.meta.to,
                    total: plugins?.meta.total
                  })
              }
            </div>
          )
        }
        <div className="col-12 col-md-auto">
          <label
            className="position-absolute ms-3 ps-1 mt-1"
            htmlFor="sort"
          >
            <small>{t('browse_all.sorting.sort_by')}</small>
          </label>
          <select
            id="sort"
            className="form-select pt-4"
            onChange={e => onSortChange(e.target.value)}
            value={sort}
          >
            <option value="MOST_POPULAR">{t('browse_all.sorting.most_popular')}</option>
            <option value="BEST_RATING">{t('browse_all.sorting.best_rating')}</option>
            <option value="NEWEST">{t('browse_all.sorting.newest') }</option>
            <option value="OLDEST">{t('browse_all.sorting.oldest') }</option>
            <option value="HIGHEST_PRICE">{t('browse_all.sorting.price_descending')}</option>
            <option value="LOWEST_PRICE">{t('browse_all.sorting.price_ascending')}</option>
          </select>
        </div>
      </div>
    </div>
  )
}
